import React from "react";
import * as FeatherIcons from "react-icons/fi";

interface Props {
  size?: number;
  icon: string;
}
const ReactIcon: React.FC<Props> = ({ size = 12, icon }) => {
  const IconComp = (FeatherIcons as any)[icon];
  if (IconComp) {
    return <IconComp size={size} />;
  }
};

export default ReactIcon;
